<div class="inline-flex items-center justify-start gap-2 self-stretch">
  <div class="flex items-center justify-start rounded-[32px] bg-zinc-300 p-2">
    <div class="relative h-4 w-4">
      <svg-icon src="assets/svg/icons/Hourglass.svg"></svg-icon>
    </div>
  </div>
  <div class="flex h-[42px] shrink grow basis-0 items-center justify-between">
    <div class="inline-flex shrink grow basis-0 flex-col items-start justify-center">
      <div class="text-xs font-bold leading-[18px] text-stone-950">History</div>
      <div class="text-base font-normal leading-normal text-stone-950">
        View your previous winnings, transactions, etc.
      </div>
    </div>
  </div>
</div>
<div class="flex h-[370px] flex-col items-start justify-start gap-2.5 self-stretch px-2 md:px-4">
  <div
    class="inline-flex w-full flex-col items-center justify-start gap-2 self-stretch md:flex-row"
  >
    <div
      class="mt-5 inline-flex w-full shrink grow basis-0 flex-col items-start justify-start gap-1 md:mt-0"
    >
      <div class="inline-flex w-full items-center justify-start gap-1">
        <div class="text-xs font-bold leading-[18px] text-stone-950">Sort By Type:</div>
      </div>

      <select
        [(ngModel)]="selectedType"
        class="inline-flex w-full items-center justify-start gap-3 self-stretch rounded-lg border border-zinc-300 bg-white py-4 pl-3 pr-1 md:text-base"
        (change)="filterChipsHistories()"
      >
        <option
          *ngFor="let chipHistoryType of chipHistoryTypes | keyvalue"
          [value]="chipHistoryType.value"
        >
          {{ chipHistoryType.value | camelCaseToTitle }}
        </option>
      </select>
    </div>

    <div
      class="mt-2 inline-flex w-full shrink grow basis-0 flex-col items-start justify-start gap-1 md:mt-5"
    >
      <div class="inline-flex w-full items-center justify-start gap-1">
        <div class="text-xs font-bold leading-[18px] text-stone-950">Sort By Date:</div>
      </div>

      <mat-form-field
        class="inline-flex h-[74px] w-full items-center text-xs md:w-full md:text-base"
      >
        <mat-date-range-input [formGroup]="datePicker" [rangePicker]="chipsPicker">
          <input matStartDate placeholder="Start date" formControlName="start" />
          <input
            matEndDate
            placeholder="End date"
            formControlName="end"
            (dateChange)="filterChipsHistories()"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="chipsPicker"></mat-datepicker-toggle>
        <mat-date-range-picker #chipsPicker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </div>
  <div class="flex w-full flex-col items-center gap-2.5 overflow-y-auto px-1">
    <div *ngIf="filteredChipHistories.length === 0">
      <p class="text-center text-lg font-bold text-stone-950">No History Data</p>
    </div>
    <ng-container *ngFor="let chipsHistory of filteredChipHistories">
      <div
        class="border-zinc-800/opacity-20 inline-flex items-center justify-start gap-4 self-stretch rounded-lg border p-2"
      >
        <div class="flex items-start justify-start gap-2.5">
          <div class="relative h-6 w-6">
            <svg-icon [src]="chipsHistory.icon!"></svg-icon>
          </div>
        </div>
        <div class="flex h-[33px] shrink grow basis-0 items-center justify-between">
          <div class="inline-flex flex-col items-start justify-start">
            <div class="text-xs font-semibold leading-[18px] text-stone-950">
              {{ chipsHistory.type | camelCaseToTitle }}
            </div>
            <div class="text-[10px] font-normal leading-[15px] text-stone-950">
              Date: {{ chipsHistory.date | date: 'MM/dd/YYYY' }}
            </div>
          </div>
          <div class="flex items-center justify-start gap-2.5">
            <div
              class="text-xs font-bold leading-[18px]"
              [ngClass]="getFontColor(chipsHistory.type)"
            >
              {{ getActionType(chipsHistory.type) }}{{ chipsHistory.value }} chips
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
